<script>
let date = new Date()
let year = date.getFullYear()
let month = date.getMonth() + 1
let day = date.getDate()
let hour = date.getHours()
let minute = date.getMinutes()
if (minute < 10) {
  minute = '0' + minute
}
var initTime = hour + ':' + minute
var initDate = year + '年' + month + '月' + day + '日'
var initWeeks = [
  '日曜日',
  '月曜日',
  '火曜日',
  '水曜日',
  '土曜日',
  '木曜日',
  '金曜日'
]
var initWeek = initWeeks[date.getDay()]
export default {
  beforeCreate: function () {
    var self = this
    setInterval(() => {
      self.getDate()
    }, 4000)
  },
  data () {
    return {
      navTitles: [
        {
          title: 'MovementStatus',
          // childrenName:[''],
          name: '運行状況',
          changebg: false
        },
        {
          title: 'MovementShift',
          name: '運行便',
          changebg: false
        },
        {
          title: 'RouteList',
          name: 'ルート',
          changebg: false
        },
        {
          title: 'StationList',
          name: '停留所',
          changebg: false
        },
        {
          title: 'VehicleList',
          name: '車両',
          changebg: false
        },
        {
          title: 'DriverList',
          name: 'ドライバー',
          changebg: false
        },
        {
          title: 'MemberList',
          name: 'アカウント管理',
          changebg: false
        }
      ],
      time: initTime,
      date: initDate,
      week: initWeek,
      weeks: initWeeks,
      tablename: 'メッセージ',
      lists: [
        {
          title: '新しい予約',
          time: '2018/05/03 10:00',
          content: '山下達彦さんが予約しました'
        },
        {
          title: '運行障害',
          time: '2018/05/04 10:00',
          content: '上地区定期便'
        },
        {
          title: '新しい予約',
          time: '2018/05/05 10:00',
          content: '山下達彦さんが予約しました'
        }
      ],
      currentPage: this.$route.name
    }
  },
  methods: {
    btnClick (value) {
      this.$router.push({ name: this.navTitles[value].title, params: { title_number: value } })
    },
    getDate: function () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      if (minute < 10) {
        minute = '0' + minute
      }
      this.time = hour + ':' + minute
      this.date = year + '年' + month + '月' + day + '日'
      this.week = this.weeks[date.getDay()]
    }
  }
}
</script>

<template>
    <div class="container navBar-color bgc1">
      <div class="nav nav-pills" >
        <div v-for="(navTitle, key) in navTitles" :key="key" class="nav-title" :class="[currentPage===navTitle.title?'changed':'']" @click="btnClick(key)" style="text-overflow:ellipsis">
          <span class="nav-title-text">{{navTitle.name}}</span>
        </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../assets/css/C00.css";
.container {
  flex: 0 0 100px;
  padding-top: 39px;
  border-bottom: 1px solid rgb(180, 210, 220);
}
.nav {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  vertical-align: middle;
  background: #b2b2b2;
  background-color: rgb(70, 165, 190);
}
.nav-title {
  background: #c8c8c8;
  width: 13.5%;
  height: 60px;
  cursor: pointer;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.nav-pills > li.active > a,
.nav-pills > li.active > a:focus,
.nav-pills > li.active > a:hover {
  background-color: #fff;
}
li:hover{
cursor: pointer;
}

.nav-title-text {
  color: #666666;
  font-size: 20px;
  line-height: 55px;
}
.changed{
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/nav-bar.vue